module.exports = __webpack_public_path__ + "img/headerlogo.6a584cc0.png";